import i18n from '@/utils/i18n';
/* eslint-disable no-extend-native */
import confirmDialog from '@/vendor/v-confirm';
import momentTimezone from 'moment-timezone';
import { checkNightAudit } from '@/api/nightTrial.js';
import operationNumber from '@/utils/numberJsCalc';
// 日期格式化的类型枚举
const dateFormateTypeEnum = {
  ymd: 'YYYY-MM-DD',
  hm: 'HH:mm',
  md: 'MM-DD',
  'ymd hm': 'YYYY-MM-DD HH:mm',
};
// 根据时区转化时间戳格式
function formateTimesStamp(time, formatType = 'YYYY-MM-DD HH:mm:ss') {
  if (typeof time === 'string' && /^[0-9]+$/.test(time)) {
    time = parseInt(time);
  }
  if (window.isLocalTimeIsRight && !/^[0-9]+$/.test(time)) {
    if (time) {
      time = new Date(time);
    } else {
      time = new Date();
    }
    return momentTimezone(new Date(time)).format(dateFormateTypeEnum[formatType] || formatType);
  }
  return momentTimezone(time)
    .tz('Asia/Choibalsan')
    .format(dateFormateTypeEnum[formatType] || formatType);
}
// 获取指定时间的时间戳
function setTimeEnd(date) {
  var localTime = date.getTime() - 8 * 3600000 - date.getTimezoneOffset() * 60000;
  return localTime;
}
/*
 * 将方法赋给window对象
 * */
window.formateTimesStamp = formateTimesStamp;
window.setTimeEnd = setTimeEnd;
export default {
  reConfirm: confirmDialog,
  /*
   * 判断当前酒店是与详情页所关联酒店是否匹配，否则弹窗遮罩提示
   * */
  judgeHotelCode(currentHotelCode) {
    const hotelCode = this.$store.getters.hotelCode;
    if (hotelCode !== currentHotelCode) {
      confirmDialog(
        `${i18n.t('globalMethodsmixin.theHotelIsCurrentlyFrom')}${currentHotelCode}${i18n.t(
          'globalMethodsmixin.switchTo'
        )}${hotelCode}！`,
        i18n.t('globalMethodsmixin.hotelChangeAlert'),
        {
          showClose: false,
          showCancelButton: false,
          confirmButtonClass: 'confirm-btn-class',
          canBtn: i18n.t('common.iGotIt2'),
          closeOnClickModal: false,
          closeOnPressEscape: false,
        }
      ).then(() => {
        window.close();
      });
    }
  },
  // 根据时区转化时间戳格式
  formateTimesStamp,
  setTimeEnd,
  async fetchCurrentTime() {
    const { date } = await this.$store.dispatch('app/fetchCurrentTime');
    return date;
  },
  /*
   * 获取乐惠支付方式（二维码or扫枪）
   * */
  async getLehuiPayWay() {
    return await this.$store.dispatch('app/fetchLehuiPayWay');
  },
  /*
   * 获取基础设置信息
   * */
  async getBaseInfoSetting() {
    return await this.$store.dispatch('app/getBaseInfoSetting', true);
  },
  // 报表打印指定区域的内容
  refPrint(ref) {
    const refTarget = this.$refs[ref];
    if (refTarget) {
      refTarget.show = true;
      this.$nextTick(() => {
        this.$print(refTarget);
        setTimeout(() => {
          refTarget.show = false;
        }, 2000);
      });
    }
  },
  // 检查当前酒店是否正在夜审
  async checkIsNightAuditing() {
    return new Promise((resolve) => {
      checkNightAudit().then((res) => {
        if (res.code === '0') {
          resolve(res.data);
        }
      });
    });
  },
};
/*
 * 拓展Number的计算方法，避免出现js数字计算的怪异行为
 * */
// eslint-disable-next-line no-extend-native
Number.prototype.plus = function (arg2) {
  return operationNumber(this, arg2, '+');
};
// 减法
// eslint-disable-next-line no-extend-native
Number.prototype.minus = function (arg2) {
  if (arg2 < 0) {
    return operationNumber(this, -arg2, '+');
  }
  return operationNumber(this, arg2, '-');
};
// 乘法
// eslint-disable-next-line no-extend-native
Number.prototype.multiply = function (arg2) {
  return operationNumber(this, arg2, '*');
};
// 除法
// eslint-disable-next-line no-extend-native
Number.prototype.division = function (arg2) {
  return operationNumber(this, arg2, '/');
};
/*
 * 重写数组的flat方法，兼容低版本浏览器
 * */
if (!Array.prototype.flat) {
  // eslint-disable-next-line no-extend-native
  Array.prototype.flat = function flatDeep(d = 1) {
    return d > 0
      ? this.reduce((acc, val) => acc.concat(Array.isArray(val) ? val.flat(d - 1) : val), [])
      : this.slice();
  };
}
if (!String.prototype.removeSpace) {
  String.prototype.removeSpace = function () {
    if (!this) {
      return '';
    }
    return this.replace(/[\s]+/g, '');
  };
}
// 创建弹出窗属性混入
window.dialogMixin = function dialogMixin(name, formRefName, event = 'close') {
  return {
    model: {
      prop: name,
      event: 'close',
    },
    props: {
      [name]: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      show: {
        get() {
          return this[name];
        },
        set(value) {
          if (!value) {
            this.$emit('close', false);
          }
        },
      },
    },
    watch: {
      show(value) {
        if (!value) {
          if (this['close']) {
            this.close();
          }
          this.commonClose();
        } else {
          this.formClear();
          if (this.init && typeof this.init === 'function') {
            this.init();
          }
        }
      },
    },
    methods: {
      formClear() {
        const refForm = this.$refs[formRefName];
        if (refForm) {
          refForm.resetFields();
        }
      },
      async validateForm() {
        await new Promise((resolve, reject) =>
          this.$refs[formRefName].validate((valid) => (valid && resolve()) || reject())
        );
      },
      commonClose() {
        if (!this.noClear && this.$options.data) {
          setTimeout(() => {
            Object.assign(this.$data, this.$options.data.call(this));
          }, 200);
        }
      },
    },
  };
};
